<template>
  <div>
    <div class="cont-foot">
      <ul class="clearfix" style="padding-bottom: 0">
        <li v-on:click="menuJump('/privacypolicy')"><span>プライバシーポリシー</span><img src="@/assets/images/foot_white_right.svg"></li>
      </ul>
      <ul class="clearfix" style="width: 100%; padding-top: 0">
        <li style="width: 100%;" v-on:click="menuJump('/storeDetailTwo')"><span>特定商取引法に基づく表記</span><img src="@/assets/images/foot_white_right.svg"></li>
      </ul>
      <div class="copyright">ⓒGong cha Japan</div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        showInquiryFlag: false,
      };
    },
    mounted() {
    },
    methods: {
      menuJump(url){
        this.$router.push({path: url});
      }
    },
  };
</script>

<style scoped>
</style>
